
const HostConfig = {
    icon: "/assets/icon/favicon.png",
    root: ""
}
export default HostConfig;